export const PUSH_SUCCESSFUL = 'PUSH_SUCCESSFUL';
export const PUSH_WARNING = 'PUSH_WARNING';
export const PUSH_DANGER = 'PUSH_DANGER';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

